export const role = {
  role: "Rôles",
  title_create: "Créer un rôle",
  form: { title: "Créer un rôle", title_edit: "Modifier un rôle" },
  create_form: {
    title: "Créer un rôle",
    name: "Nom",
    name_placeholder: "Nom du rôle",

    submit: "Créer",
    creating: "Création...",
    updating: "Mise à jour...",
    update: "Modifier",
    create_success: "Rôle créé avec succès !",
    update_success: "Rôle mis à jour avec succès !",
    deactivate_success: "Rôle désactivé avec succès !",
    create_error: "Erreur lors de la création du rôle",
    update_error: "Erreur lors de la mise à jour du rôle",
    deactivate_error: "Erreur lors de la désactivation du rôle",
    status: "Statut",
    permission: "Permissions",
  },

  permission: {
    CREATE_COMPANY: "Créer une société",
    UPDATE_COMPANY: "Modifier une société",
    DELETE_COMPANY: "Supprimer une société",
    READ_COMPANY: "Voir les sociétés",

    CREATE_CONTRAT: "Créer un contrat",
    READ_CONTRAT: "Voir les contrats",

    CREATE_INVOICE: "Créer une facture",
    READ_INVOICE: "Voir les factures",
    UPDATE_INVOICE: "Modifier une facture",
    DELETE_INVOICE: "Supprimer une facture",

    CREATE_QUOTE: "Créer un devis",
    READ_QUOTE: "Voir les devis",
    UPDATE_QUOTE: "Modifier un devis",
    DELETE_QUOTE: "Supprimer un devis",

    CREATE_SUPPLIER: "Créer un fournisseur",
    READ_INVOICE_SUPPLIER: "Voir les factures fournisseur",

    CREATE_CREDIT_NOTE: "Créer un avoir",
    READ_CREDIT_NOTE: "Voir les avoirs",
    UPDATE_CREDIT_NOTE: "Modifier un avoir",
    DELETE_CREDIT_NOTE: "Supprimer un avoir",

    CREATE_EXPENSE: "Créer une dépense",
    READ_EXPENSE: "Voir les dépenses",
    UPDATE_EXPENSE: "Modifier une dépense",
    DELETE_EXPENSE: "Supprimer une dépense",

    CREATE_CLIENT: "Créer un client",
    READ_CLIENT: "Voir les clients",
    UPDATE_CLIENT: "Modifier un client",
    DELETE_CLIENT: "Supprimer un client",

    CREATE_OFFER: "Créer une offre",
    READ_OFFER: "Voir les offres",
    UPDATE_OFFER: "Modifier une offre",
    DELETE_OFFER: "Supprimer une offre",

    CREATE_USER: "Créer un utilisateur",
    EDIT_USER: "Modifier un utilisateur",
    DELETE_USER: "Supprimer un utilisateur",
    READ_USER: "Voir les utilisateurs",

    create_role: "Créer un rôle",
    edit_role: "Modifier un rôle",
    delete_role: "Supprimer un rôle",
    view_role: "Voir les rôles",

    view_dashboard: "Voir le tableau de bord",
    SIGNATURE: "Signer",
    DOCUMENT: "Documents",
    CONFIGURATION: "Configuration",
    VALIDATEUR: "Validateur",
  },

  actions: {
    edit: "Modifier",
    disable: "Désactiver",
    enable: "Activer",
    consulter: "Consulter",
  },

  header_title: "Liste des rôles",
  table: {
    status: "Statut",
    isVerified: "Vérifié",
    createdAt: "Date de création",
  },
  COMPANY: "Société",
  CONTRAT: "Contrat",
  INVOICE: "Facture",
  QUOTE: "Devis",
  SUPPLIER: "Fournisseur",
  CREDIT_NOTE: "Avoir",
  EXPENSE: "Dépense",
  CLIENT: "Client",
  OFFER: "Offre",
  USER: "Utilisateur",
  ROLE: "Rôle",
  DASHBOARD: "Tableau de bord",
  OTHER: "Autre",
};
